// KinsCircle "What's New" change log
// ─────────────────────────────────────────────────────────────────────────────
// This file powers the "Updates" tab inside the in-app Guide modal.
//
// HOW TO ADD A NEW UPDATE:
//   1. Add a new entry to the TOP of the `GUIDE_UPDATES` array below.
//   2. Use today's date in `YYYY-MM-DD` format for `date`.
//   3. Pick a `tag` from: 'new' | 'fix' | 'improved'.
//   4. Keep `title` short (one line) and `body` to 1–2 sentences in plain English.
//   5. Save the file. The Guide modal reads this list on every open — no
//      rebuild, no backend change, no migration is required.
//
// The newest entry is shown first. There is no hard limit on the number of
// entries; old items simply scroll inside the Updates tab.

export type GuideUpdateTag = 'new' | 'fix' | 'improved';

export interface GuideUpdate {
  /** ISO date string, e.g. "2026-05-03". */
  date: string;
  /** Category badge shown next to the title. */
  tag: GuideUpdateTag;
  /** Short headline. */
  title: string;
  /** 1–2 sentence plain-English description. */
  body: string;
}

export const GUIDE_UPDATES: GuideUpdate[] = [
  {
    date: '2026-05-03',
    tag: 'fix',
    title: 'New relatives connect instantly — no more bottom row',
    body:
      'When you add a sibling, cousin, aunt/uncle, or child you now pick how they relate first, and they land in the right spot on the tree right away. The bottom "Needs connection" row is reserved for older incomplete profiles only.',
  },
  {
    date: '2026-05-03',
    tag: 'new',
    title: 'Top-of-screen Guide button',
    body:
      'A "Guide" button now lives at the top of every page so help is one tap away. The full how-it-works walkthrough and "What\'s New" updates live inside.',
  },

  {
    date: '2026-05-03',
    tag: 'improved',
    title: 'Each side of the family stays separate',
    body:
      'You now only see your own bloodline — your ancestors, descendants, siblings, and cousins. The other parent\'s extended family is private to their branch.',
  },
  {
    date: '2026-05-03',
    tag: 'fix',
    title: 'Invited family members land in the right tree',
    body:
      'When someone you invited signs up, their account is now bound to the existing profile in your tree instead of opening a separate empty one.',
  },
  {
    date: '2026-05-03',
    tag: 'improved',
    title: 'Smarter automatic placement',
    body:
      'Tap any person, choose how someone is related, and KinsCircle puts them in the right generation row automatically. No manual dragging needed.',
  },
  {
    date: '2026-05-03',
    tag: 'new',
    title: 'Bloodline privacy banner',
    body:
      'When the tree filters down to your side of the family, a small emerald banner explains what you\'re seeing so nothing feels missing.',
  },
];
